(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["popup"]) return;
  try {
    
  (function () {
    var LOCK_ATTR = 'data-vp-popup-locked';

    function lockModal(modal) {
      if (!modal || modal.getAttribute(LOCK_ATTR) === 'true') return;
      var width = Math.round(modal.getBoundingClientRect().width);
      if (width < 8) return;
      modal.style.setProperty('--vp-popup-locked-width', width + 'px');
      modal.setAttribute(LOCK_ATTR, 'true');
    }

    function lockVisible(root) {
      var scope = root || document;
      var modals = scope.querySelectorAll('.cc-popup.cc-popup--visible .cc-popup-modal--layout-image-only');
      for (var i = 0; i < modals.length; i += 1) {
        lockModal(modals[i]);
      }
    }

    var observer = new MutationObserver(function () {
      lockVisible(document);
    });

    function start() {
      lockVisible(document);
      if (document.body) {
        observer.observe(document.body, {
          attributes: true,
          subtree: true,
          attributeFilter: ['class']
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', function (event) {
      lockVisible(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vp-cyber-hero-signup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function focusSuccess(root) {
      if (!root) return;
      var success = root.querySelector('[data-vp-cyber-success]');
      if (!success) return;
      if (typeof success.scrollIntoView === 'function') {
        success.scrollIntoView({ block: 'center' });
      }
      success.focus();
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-vp-cyber-hero]');
      for (var i = 0; i < roots.length; i += 1) {
        focusSuccess(roots[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      focusSuccess(event.target.querySelector('[data-vp-cyber-hero]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vp-technology-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var instances = new WeakMap();

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function currentIndex(tabs) {
      var i;
      for (i = 0; i < tabs.length; i += 1) {
        if (tabs[i].getAttribute('aria-selected') === 'true') return i;
      }
      return 0;
    }

    function restartTimer(root) {
      var ring = root.querySelector('.vp-tech-tabs__tab.is-active .vp-tech-tabs__timer-ring');
      if (!ring) return;
      ring.style.animation = 'none';
      void ring.getBoundingClientRect();
      ring.style.animation = '';
    }

    function activate(root, index) {
      var tabs = root.querySelectorAll('[role="tab"]');
      var panels = root.querySelectorAll('[role="tabpanel"]');
      var i;

      for (i = 0; i < tabs.length; i += 1) {
        var selected = i === index;
        tabs[i].setAttribute('aria-selected', selected ? 'true' : 'false');
        tabs[i].tabIndex = selected ? 0 : -1;
        tabs[i].classList.toggle('is-active', selected);
      }

      for (i = 0; i < panels.length; i += 1) {
        var match = panels[i].getAttribute('data-vp-tech-index') === String(index);
        panels[i].hidden = !match;
        panels[i].classList.toggle('is-active', match);
      }
    }

    function init(root) {
      if (!root || instances.has(root)) return;

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      if (!tabs.length) return;

      var autoplayEnabled = root.getAttribute('data-autoplay') === 'true';
      var duration = Math.max(3, parseInt(root.getAttribute('data-autoplay-speed'), 10) || 6) * 1000;
      var remaining = duration;
      var startedAt = 0;
      var timerId = null;
      var pauseReasons = {
        hover: false,
        focus: false,
        offscreen: true,
        reduced: prefersReducedMotion()
      };
      var observer = null;
      var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      function isFullyPaused() {
        return (
          !autoplayEnabled ||
          pauseReasons.hover ||
          pauseReasons.focus ||
          pauseReasons.offscreen ||
          pauseReasons.reduced
        );
      }

      function pauseClock() {
        if (timerId !== null) {
          clearTimeout(timerId);
          timerId = null;
        }
        if (startedAt) {
          remaining -= Date.now() - startedAt;
          startedAt = 0;
        }
      }

      function resumeClock() {
        if (isFullyPaused() || timerId !== null) return;
        if (remaining <= 0) remaining = duration;
        startedAt = Date.now();
        timerId = setTimeout(onTick, remaining);
      }

      function resetClock() {
        pauseClock();
        remaining = duration;
        restartTimer(root);
        if (!isFullyPaused()) resumeClock();
      }

      function onTick() {
        timerId = null;
        startedAt = 0;
        remaining = duration;
        var next = (currentIndex(tabs) + 1) % tabs.length;
        activate(root, next);
        restartTimer(root);
        if (!isFullyPaused()) resumeClock();
      }

      function syncPaused() {
        var paused = isFullyPaused();
        root.classList.toggle('is-paused', paused);
        if (paused) pauseClock();
        else resumeClock();
      }

      function setPauseReason(key, value) {
        pauseReasons[key] = value;
        syncPaused();
      }

      function onClick(event) {
        var index = parseInt(event.currentTarget.getAttribute('data-vp-tech-index'), 10);
        activate(root, index);
        resetClock();
      }

      function onKey(event) {
        var keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
        if (keys.indexOf(event.key) === -1) return;
        event.preventDefault();
        var current = tabs.indexOf(event.currentTarget);
        var next = current;
        if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          next = (current - 1 + tabs.length) % tabs.length;
        } else {
          next = (current + 1) % tabs.length;
        }
        activate(root, next);
        tabs[next].focus();
        resetClock();
      }

      function onMouseEnter() {
        setPauseReason('hover', true);
      }

      function onMouseLeave() {
        setPauseReason('hover', false);
      }

      function onFocusIn(event) {
        if (event.target.closest('[role="tab"]')) {
          setPauseReason('focus', true);
        }
      }

      function onFocusOut(event) {
        var next = event.relatedTarget;
        if (next && root.contains(next) && next.closest('[role="tab"]')) return;
        setPauseReason('focus', false);
      }

      function onMotionChange(event) {
        setPauseReason('reduced', event.matches);
      }

      for (var i = 0; i < tabs.length; i += 1) {
        tabs[i].addEventListener('click', onClick);
        tabs[i].addEventListener('keydown', onKey);
      }

      root.addEventListener('mouseenter', onMouseEnter);
      root.addEventListener('mouseleave', onMouseLeave);
      root.addEventListener('focusin', onFocusIn);
      root.addEventListener('focusout', onFocusOut);

      if (motionQuery.addEventListener) {
        motionQuery.addEventListener('change', onMotionChange);
      } else if (motionQuery.addListener) {
        motionQuery.addListener(onMotionChange);
      }

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(
          function (entries) {
            var entry = entries[0];
            setPauseReason('offscreen', !(entry && entry.isIntersecting));
          },
          { threshold: 0 }
        );
        observer.observe(root);
      } else {
        setPauseReason('offscreen', false);
      }

      syncPaused();
      root.classList.add('is-enhanced');
      instances.set(root, {
        tabs: tabs,
        onClick: onClick,
        onKey: onKey,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocusIn: onFocusIn,
        onFocusOut: onFocusOut,
        onMotionChange: onMotionChange,
        motionQuery: motionQuery,
        observer: observer,
        pauseClock: pauseClock
      });
    }

    function destroy(root) {
      var inst = instances.get(root);
      if (!inst) return;
      var i;
      if (inst.pauseClock) inst.pauseClock();
      for (i = 0; i < inst.tabs.length; i += 1) {
        inst.tabs[i].removeEventListener('click', inst.onClick);
        inst.tabs[i].removeEventListener('keydown', inst.onKey);
      }
      root.removeEventListener('mouseenter', inst.onMouseEnter);
      root.removeEventListener('mouseleave', inst.onMouseLeave);
      root.removeEventListener('focusin', inst.onFocusIn);
      root.removeEventListener('focusout', inst.onFocusOut);
      if (inst.motionQuery) {
        if (inst.motionQuery.removeEventListener) {
          inst.motionQuery.removeEventListener('change', inst.onMotionChange);
        } else if (inst.motionQuery.removeListener) {
          inst.motionQuery.removeListener(inst.onMotionChange);
        }
      }
      if (inst.observer) inst.observer.disconnect();
      instances.delete(root);
    }

    function initAll() {
      var roots = document.querySelectorAll('.vp-tech-tabs');
      for (var i = 0; i < roots.length; i += 1) {
        init(roots[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('.vp-tech-tabs');
      if (root) init(root);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target.querySelector('.vp-tech-tabs');
      if (root) destroy(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
